export default {
	cinema: {
		address: 'бул. Петровский, 7',
		place: null,
		phoneNumbers: ['8 (952) 607-03-05'],
		facebook: null,
		instagram: null,
		vk: 'https://vk.com/azovkino',
		twitter: null,
		odnoklassniki: null,
		youtube: null,
		app: {
			appstore: null,
			googleplay: null,
		},
		payment: {
			active: true,
			card: ['mir', 'visa', 'mastercard', 'maestro', 'sbp', 'sberpay'],
		},
		maps: 'https://yandex.ru/maps/-/CGhsfN4I',
		selectButton: {
			options: [],
			selectedOptionValue: null,
		},
		soonPageIsEnabled: false,
		saleRules: false,
		details: false,
	},
	feedback: true,
};
